const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;
const FULL_HUE_CIRCLE = 360;
const BASE_SATURATION = 70;
const SATURATION_VARIATION = 8;
const BASE_LIGHTNESS = 56;
const LIGHTNESS_VARIATION = 10;

const toPositiveInt = (value: number) => (value >>> 0);

export const getDeterministicColor = (input: string): string => {
    // FNV-1a 32-bit hash for stable string hashing
    let hash = FNV_OFFSET_BASIS;
    for (let i = 0; i < input.length; i++) {
        hash ^= input.charCodeAt(i);
        hash = toPositiveInt(hash * FNV_PRIME);
    }

    // Use hash to generate visually distinct HSL values for dark backgrounds
    const hue = hash % FULL_HUE_CIRCLE;
    const saturation = BASE_SATURATION + (hash % SATURATION_VARIATION); // 70-77%
    const lightness = BASE_LIGHTNESS + (hash % LIGHTNESS_VARIATION); // 56-65%

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
